import React, { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import FormInputs from "../../Components/Shared/FormInputs/FormInputs";
import DropDown from "../../Components/Shared/Dropdown/Dropdown";
import ErrorImg from "../../Assets/Images/CommanImages/Error.png";
import InterogativeImg from "../../Assets/Images/CommanImages/Interogative.png";
import { FULL_API_BASE_URL } from "../../Config/Config";
import { fetchCourseData } from "../../Redux/StudentRegistration/courseSlice";
import { fetchSessionData } from "../../Redux/Sessions/sessionSlice";
import MultiSeledDropdown from "../CreateQuestionsPaper/MultiDropdown/MultiSeledDropdown";
import SingleSelectSearchDropdown from "./SingleSelectSearchDropdown";
import DropdownWithPagination from "./DropdownWithPagination";
import TableWithCrossStudentGroup from "./TableWithCrossStudentGroup";
import EndPoints from "../../Api/EndPoints";
import { Comments } from "docx";
import "./studentgroup.css";
import MultiSelectedWithDiabled from "./MultiSelectedWithDiabled";

function StudentGroup({
  dataClient,
  setMessageBox,
  messageBox,
  setIsMessageBoxVisible,
  setActiveImg,
}) {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { coursesdata } = useSelector((state) => state.course);
  const { sessionsData } = useSelector((state) => state.sessions);

  const [selectedCourse, setSelectedCourse] = useState(null);
  const [subjects, setSubjects] = useState([]);
  const [selectedSubjects, setSelectedSubjects] = useState([]);
  const [selectedSession, setSelectedSession] = useState(null);
  const [studentGroupName, setStudentGroupName] = useState("");
  const [studentGroupDesc, setStudentGroupDesc] = useState("");
  const [comments, setComments] = useState("");

  const [facultyOptions, setFacultyOptions] = useState([]);
  const [selectedCoordinator, setSelectedCoordinator] = useState(null);

  const [branchOptions, setBranchOptions] = useState([]);
  const [selectedBranches, setSelectedBranches] = useState([]);

  const userName = dataClient?.client_schema_name?.[6]?.[0]?.user_name || null;
  const clientBranchId =
    dataClient?.client_schema_name?.[6]?.[0]?.client_branch_id;
  const clientId = dataClient?.client_schema_name?.[6]?.[0]?.client_id;
  const accessToken = localStorage.getItem("other");

  const [isOpenShareBranch, setIsOpenShareBranch] = useState(true);
  const toggleAccordionShareBranch = () =>
    setIsOpenShareBranch(!isOpenShareBranch);

  // --- Student related state ---
  const [studentOptions, setStudentOptions] = useState([]);
  const [selectedStudents, setSelectedStudents] = useState([]);

  // Use ref to prevent infinite loop
  const isUpdatingFromTable = useRef(false);

  // Fetch courses and sessions
  useEffect(() => {
    dispatch(fetchCourseData());
    dispatch(fetchSessionData());
  }, [dispatch]);

  // Fetch subjects when course changes
  useEffect(() => {
    if (selectedCourse) {
      fetch(
        `${FULL_API_BASE_URL}/get-subjects-by-course/?course_id=${selectedCourse}`
      )
        .then((res) => res.json())
        .then((data) => {
          const fetchedSubjects = data || [];
          setSubjects(fetchedSubjects);
          setSelectedSubjects(fetchedSubjects.map((s) => s.subject_id));
        })
        .catch((err) => console.error("Error fetching subjects:", err));
    } else {
      setSubjects([]);
      setSelectedSubjects([]);
    }
  }, [selectedCourse]);

  // Fetch faculty list by search key
  const fetchFaculty = (searchKey) => {
    if (!searchKey) {
      setFacultyOptions([]);
      return;
    }
    fetch(
      `${FULL_API_BASE_URL}/get-faculty-list-by-searchkey/?search_key=${searchKey}`,
      {
        headers: { Authorization: `Bearer ${accessToken}` },
      }
    )
      .then((res) => res.json())
      .then((data) => {
        const options = (data || []).map((f) => ({
          label:
            `${f.emp_first_name} ${f.emp_middle_name} ${f.emp_last_name}`.trim(),
          id: f.emp_id,
          manager_emp_id: f.manager_emp_id,
        }));
        setFacultyOptions(options);
      })
      .catch((err) => console.error("Error fetching faculty:", err));
  };

  // Fetch students (store fullData)
  // const fetchStudents = (searchKey) => {
  //   if (!searchKey) {
  //     setStudentOptions([]);
  //     return;
  //   }

  //   const params = new URLSearchParams();
  //   params.append("search_key", searchKey);
  //   if (selectedCourse) params.append("course_id", selectedCourse);
  //   if (selectedSession) params.append("session_id", selectedSession);

  //   fetch(`${FULL_API_BASE_URL}/search-student-across-branches?${params.toString()}`, {
  //     headers: { Authorization: `Bearer ${accessToken}` },
  //   })
  //     .then((res) => res.json())
  //     .then((data) => {
  //       setStudentOptions(
  //         (data || []).map((s) => ({
  //           label: `${s.student_full_name} (${s.roll_number}) - ${s.branch_name}`,
  //           id: s.student_id,
  //           fullData: s,
  //         }))
  //       );
  //     })
  //     .catch((err) => console.error(err));
  // };

  // const fetchStudents = (searchKey) => {
  //   if (!searchKey) {
  //     setStudentOptions([]);
  //     return;
  //   }

  //   const params = new URLSearchParams();
  //   params.append("search_key", searchKey);
  //   if (selectedCourse) params.append("course_id", selectedCourse);
  //   if (selectedSession) params.append("session_id", selectedSession);

  //   fetch(`${FULL_API_BASE_URL}/search-student-across-branches?${params.toString()}`, {
  //     headers: { Authorization: `Bearer ${accessToken}` },
  //   })
  //     .then((res) => res.json())
  //     .then((data) => {
  //       console.log("Fetched students:", data); // Debug log
  //       setStudentOptions(
  //         (data || []).map((s) => ({
  //           label: `${s.student_full_name} (${s.roll_number}) - ${s.batch_name || s.branch_name}`,
  //           id: s.student_id,
  //           fullData: s,
  //         }))
  //       );
  //     })
  //     .catch((err) => console.error("Error fetching students:", err));
  // };

  const fetchStudents = (searchKey) => {
    if (!searchKey) {
      // Don't clear options when search is empty - keep selected students visible
      return;
    }

    const params = new URLSearchParams();
    params.append("search_key", searchKey);
    if (selectedCourse) params.append("course_id", selectedCourse);
    if (selectedSession) params.append("session_id", selectedSession);

    fetch(
      `${FULL_API_BASE_URL}/search-student-across-branches?${params.toString()}`,
      {
        headers: { Authorization: `Bearer ${accessToken}` },
      }
    )
      .then((res) => res.json())
      .then((data) => {
        console.log("Fetched students:", data);

        // Map new results to options format
        const newOpts = (data || []).map((s) => ({
          label: `${s.student_full_name} (${s.roll_number}) - ${
            s.batch_name || s.branch_name
          }`,
          id: s.student_id,
          fullData: s,
        }));

        // MERGE with existing options (preserve previously selected students)
        setStudentOptions((prev = []) => {
          const map = new Map();
          // Add new search results first (so they appear at top)
          newOpts.forEach((n) => map.set(String(n.id), n));
          // Keep previous options that aren't in the new results
          prev.forEach((p) => {
            if (!map.has(String(p.id))) {
              map.set(String(p.id), p);
            }
          });
          return Array.from(map.values());
        });
      })
      .catch((err) => console.error("Error fetching students:", err));
  };

  const clientBranchNum = clientBranchId ? Number(clientBranchId) : null;
  const normalizedSelectedBranches = Array.isArray(selectedBranches)
    ? selectedBranches.map((id) => Number(id))
    : [];

  let branchIdsPayload = [];
  if (normalizedSelectedBranches.length === 0) {
    if (clientBranchNum !== null) branchIdsPayload = [clientBranchNum];
  } else {
    const set = new Set(normalizedSelectedBranches);
    if (clientBranchNum !== null) set.add(clientBranchNum);
    branchIdsPayload = Array.from(set);
  }

  useEffect(() => {
    const resolvedClientId =
      clientBranchId ||
      (() => {
        try {
          const stored = localStorage.getItem("client_branch_id");
          return stored ? Number(stored) : null;
        } catch (e) {
          return null;
        }
      })();

    if (!resolvedClientId) {
      console.debug(
        "fetchBranches: waiting for clientBranchId to be available"
      );
      return;
    }

    const fetchBranches = async () => {
      try {
        const token = localStorage.getItem("other");
        const res = await fetch(
          `${FULL_API_BASE_URL}/get-branch-list?client_id=${clientId}`,
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );
        const json = await res.json();

        if (json && json.status === 200 && Array.isArray(json.data)) {
          // normalize options
          const opts = json.data.map((b) => ({
            label: `${b.branch_name} / ${b.city_name} / ${b.state_name}`,
            id: b.branch_id,
            disabled: Number(b.branch_id) === clientBranchNum,
          }));
          setBranchOptions(opts);
        } else {
          console.warn("fetchBranches: unexpected response", json);
          setBranchOptions([]);
        }
      } catch (err) {
        console.error("Error fetching branches:", err);
        setBranchOptions([]);
      }
    };

    fetchBranches();
  }, [clientBranchId, dataClient, clientBranchNum]);

  // Build data array for TableWithCrossStudentGroup
  const headers = [
    "",
    "Student Name",
    "Roll Number",
    "Course",
    "Batch",
    "Branch",
    "Class Type",
    "Status",
  ];

  const tableData = (Array.isArray(selectedStudents) ? selectedStudents : [])
    .map((studentId) => {
      const opt = studentOptions.find((o) => o.id === studentId);
      if (!opt || !opt.fullData) return null;
      const s = opt.fullData;
      return [
        studentId, // 0 -> id (required by table)
        s.student_full_name || "---", // 1 -> name
        s.roll_number || "---", // 2 -> roll
        s.course_name || "---", // 3 -> course
        s.batch_name || "---", // 4 -> batch
        s.branch_name || "---", // 5 -> branch
        s.class_type || "---", // 6 -> class type
        s.status || 0, // 7 -> status/flag
      ];
    })
    .filter(Boolean);

  // Handle row selection changes from table
  const handleTableRowSelection = (newSelectedRows) => {
    isUpdatingFromTable.current = true;
    setSelectedStudents(newSelectedRows);
    // Reset flag after state update
    setTimeout(() => {
      isUpdatingFromTable.current = false;
    }, 0);
  };

  // Delete row handler
  const handleDeleteRow = (rowId) => {
    setStudentOptions((prev) => prev.filter((o) => o.id !== rowId));
    setSelectedStudents((prev) => prev.filter((id) => id !== rowId));
  };

  const handleSaveGroup = async () => {
    if (
      !studentGroupName.trim() ||
      !studentGroupDesc.trim() ||
      !selectedCoordinator ||
      !selectedSession ||
      !selectedCourse ||
      !selectedSubjects
    ) {
      let message = "Please fill all required fields before saving.";

      if (!studentGroupName.trim())
        message = "Please enter the Student Group Name.";
      else if (!studentGroupDesc.trim())
        message = "Please enter the Student Group Description.";
      else if (!selectedCoordinator)
        message = "Please select a Group Coordinator.";
      else if (!selectedSession) message = "Please select a Session.";
      else if (!selectedCourse) message = "Please select a Course.";
      else if (!selectedSubjects || selectedSubjects.length === 0)
        message = "Please select at least one Subject.";

      setIsMessageBoxVisible(true);
      setMessageBox(
        <div className="Container-messageBOX">
          <div className="messagebox-insider1">
            <div className="loader-tc"></div>
            <span>{message}</span>
          </div>
        </div>
      );
      setActiveImg(ErrorImg);
      return;
    }

    if (!selectedStudents || selectedStudents.length === 0) {
      setIsMessageBoxVisible(true);
      setMessageBox(
        <div className="Container-messageBOX">
          <div className="messagebox-insider1">
            <div className="loader-tc"></div>
            <span>Please select at least one student before saving.</span>
          </div>
        </div>
      );
      setActiveImg(ErrorImg);
      return;
    }

    const payload = {
      student_ids: selectedStudents.map((id) => Number(id)),
      branch_ids: branchIdsPayload,
      subject_ids: selectedSubjects.map((id) => Number(id)),
    };

    let url =
      `${FULL_API_BASE_URL}/create-student-group` +
      `?student_group_name=${encodeURIComponent(studentGroupName)}` +
      `&student_group_desc=${encodeURIComponent(studentGroupDesc)}` +
      `&comments=${encodeURIComponent("")}` +
      `&course_id=${selectedCourse}` +
      `&session_id=${selectedSession}` +
      `&student_group_coord_emp_id=${Number(selectedCoordinator)}` +
      `&client_branch_id=${clientBranchId}` +
      `&username=${encodeURIComponent(userName)}`;
    if (comments && comments.trim().length > 0) {
      url += `&comments=${encodeURIComponent(comments.trim())}`;
    }
    try {
      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
        body: JSON.stringify(payload),
      });
      const data = await response.json();

      if (data.status === 200) {
        setIsMessageBoxVisible(true);
        setMessageBox(
          <div className="Container-messageBOX">
            <div className="messagebox-insider1">
              <div className="loader-tc"></div>
              <span>Student group created successfully!</span>
            </div>
          </div>
        );
        setActiveImg(InterogativeImg);
        setTimeout(() => {
          navigate("/student_group_dashboard");
        }, 2000);
      } else {
        setIsMessageBoxVisible(true);
        setMessageBox(
          <div className="Container-messageBOX">
            <div className="messagebox-insider1">
              <div className="loader-tc"></div>
              <span>
                {data.message ||
                  "Failed to create student group. Please try again."}
              </span>
            </div>
          </div>
        );
        setActiveImg(ErrorImg);
      }
    } catch (error) {
      console.error("Error creating student group:", error);
      setIsMessageBoxVisible(true);
      setMessageBox(
        <div className="Container-messageBOX">
          <div className="messagebox-insider1">
            <div className="loader-tc"></div>
            <span>
              An unexpected error occurred while creating the student group.
              Please try again.
            </span>
          </div>
        </div>
      );
      setActiveImg(ErrorImg);
    }
  };

  // near your state declarations (already have clientBranchNum)
  const handleSetSelectedBranches = (vals) => {
    // vals might be array of ids (strings or numbers) depending on dropdown implementation
    const filtered = Array.isArray(vals)
      ? vals.filter((v) => Number(v) !== clientBranchNum)
      : [];
    setSelectedBranches(filtered);
  };

  return (
    <div className="create-role-container">
      <div className="create-role-container-ques-paper-del">
        <span className="create-role-heading">Student Group</span>
        <div className="cr-header-btn-container">
          <button
            className="cr-cancel-btn"
            onClick={() => navigate("/student_group_dashboard")}
          >
            CANCEL
          </button>
          <button className="cr-create-btn" onClick={handleSaveGroup}>
            SAVE
          </button>
        </div>
      </div>

      <div className="ques-paper-del">
        <div className="personal-header">
          <div className="header">
            <label>USER DETAILS</label>
          </div>
        </div>

        <div className="accordion-content">
          <div className="select-assign-test-container-ques-pap-del">
            <div className="grid-container-ques-paper-del">
              <div className="item1">
                <FormInputs
                  label="Student Group Name"
                  type="text"
                  required
                  value={studentGroupName}
                  onChange={(e) => setStudentGroupName(e.target.value)}
                />
              </div>

              <div className="item2">
                <FormInputs
                  label="Student Group Description"
                  type="text"
                  required
                  value={studentGroupDesc}
                  onChange={(e) => setStudentGroupDesc(e.target.value)}
                />
              </div>

              <div className="item2">
                <SingleSelectSearchDropdown
                  label="Group Coordinator"
                  width="100%"
                  singleSelect={true}
                  selected={selectedCoordinator}
                  setSelected={setSelectedCoordinator}
                  options={facultyOptions}
                  placeholder="Search and select Coordinator..."
                  onSearchInputChange={fetchFaculty}
                  isRequired={true}
                />
              </div>
              <div className="item3">
                <DropDown
                  label="Session"
                  selected={selectedSession}
                  setSelected={setSelectedSession}
                  options={
                    Array.isArray(sessionsData)
                      ? sessionsData.map((session) => ({
                          label: session.session_name,
                          id: session.session_id,
                        }))
                      : []
                  }
                  isRequired={true}
                />
              </div>

              <div className="item4">
                <DropDown
                  label="Course"
                  selected={selectedCourse}
                  setSelected={(val) => setSelectedCourse(val)}
                  options={
                    Array.isArray(coursesdata)
                      ? coursesdata.map((course) => ({
                          label: course.course_name,
                          id: course.course_id,
                        }))
                      : []
                  }
                  isRequired={true}
                />
              </div>

              <div className="item5">
                <MultiSeledDropdown
                  label="Subjects"
                  width="100%"
                  selected={selectedSubjects}
                  setSelected={setSelectedSubjects}
                  options={subjects.map((subject) => ({
                    label: subject.subject_name,
                    id: subject.subject_id,
                  }))}
                  showSelectAll={true}
                  isRequired={true}
                />
              </div>

              <div className="item6">
                <MultiSelectedWithDiabled
                  label="Extend To Branch"
                  width="100%"
                  selected={selectedBranches}
                  // setSelected={setSelectedBranches}
                  setSelected={handleSetSelectedBranches}
                  options={branchOptions}
                  showSelectAll={true}
                  placeholder="Select branch to extend this group"
                />
              </div>

              <div className="item7-student-group-details-comments">
                <FormInputs
                  label="Comments"
                  type="text"
                  value={comments}
                  onChange={(e) => setComments(e.target.value)}
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="ques-paper-del" style={{ marginTop: "20px" }}>
        <div className="personal-header">
          <div className="header">
            <label>ADD STUDENTS</label>
          </div>
          <div className="accordion-btn" onClick={toggleAccordionShareBranch}>
            {isOpenShareBranch ? (
              <div className="minus"></div>
            ) : (
              <div className="plus">+</div>
            )}
          </div>
        </div>
        {isOpenShareBranch && (
          <div className="accordion-content">
            <div
              className="select-assign-test-container-ques-pap-del"
              style={{ padding: "20px 0px 20px 0px" }}
            >
              <div className="grid-container-ques-paper-del">
                <div className="item1" style={{ marginLeft: "20px" }}>
                  <DropdownWithPagination
                    label="Add Students"
                    width="100%"
                    selected={selectedStudents}
                    setSelected={setSelectedStudents}
                    onSearchInputChange={fetchStudents}
                    options={studentOptions}
                    isRequired={false}
                    showSelectAll={false}
                    itemsPerPage={4}
                  />
                </div>
                <div style={{ gridColumn: "1 / -1" }}>
                  <TableWithCrossStudentGroup
                    headers={headers}
                    data={tableData}
                    searchPlaceholder="Search students..."
                    selectedRows={selectedStudents}
                    setSelectedRows={handleTableRowSelection}
                    renderQuestionText={(text) => text}
                    renderQuestionTextModel={(text) => text}
                    expandedStates={{}}
                    toggleImage={() => {}}
                    pageType="userEdit"
                    onRowLinkClick={(row) => console.log("Row clicked:", row)}
                    filterConfig={{}}
                    handleDeleteRow={handleDeleteRow}
                    hideIdColumn={true}
                  />
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default StudentGroup;

// import React, { useState, useEffect } from "react";
// import { useDispatch, useSelector } from "react-redux";
// import { useNavigate } from "react-router-dom";
// import FormInputs from "../../Components/Shared/FormInputs/FormInputs";
// import DropDown from "../../Components/Shared/Dropdown/Dropdown";
// import ErrorImg from "../../Assets/Images/CommanImages/Error.png";
// import InterogativeImg from "../../Assets/Images/CommanImages/Interogative.png";
// import { FULL_API_BASE_URL } from "../../Config/Config";
// import { fetchCourseData } from "../../Redux/StudentRegistration/courseSlice";
// import { fetchSessionData } from "../../Redux/Sessions/sessionSlice";
// import MultiSeledDropdown from "../CreateQuestionsPaper/MultiDropdown/MultiSeledDropdown";
// import SingleSelectSearchDropdown from "./SingleSelectSearchDropdown";
// import DropdownWithPagination from "./DropdownWithPagination";
// import AddSearchStudentTable from "./AddSearchStudentTable";

// function StudentGroup({ dataClient, setMessageBox, messageBox, setIsMessageBoxVisible, setActiveImg }) {
//   const navigate = useNavigate();
//   const dispatch = useDispatch();
//   const { coursesdata } = useSelector((state) => state.course);
//   const { sessionsData } = useSelector((state) => state.sessions);

//   const [selectedCourse, setSelectedCourse] = useState(null);
//   const [subjects, setSubjects] = useState([]);
//   const [selectedSubjects, setSelectedSubjects] = useState([]);
//   const [selectedSession, setSelectedSession] = useState(null);
//   const [studentGroupName, setStudentGroupName] = useState("");
//   const [studentGroupDesc, setStudentGroupDesc] = useState("");

//   const [facultyOptions, setFacultyOptions] = useState([]);
//   const [selectedCoordinator, setSelectedCoordinator] = useState(null);

//   const userName = dataClient?.client_schema_name?.[6]?.[0]?.user_name || null;
//   const clientBranchId = dataClient?.client_schema_name?.[6]?.[0]?.client_branch_id;
//   const accessToken = localStorage.getItem("other");

//   const [isOpenShareBranch, setIsOpenShareBranch] = useState(true);

//   const [studentOptions, setStudentOptions] = useState([]);
//   const [selectedStudents, setSelectedStudents] = useState([]);
//   const [isStudentTableVisible, setIsStudentTableVisible] = useState(false);

//   const toggleAccordionShareBranch = () => {
//     setIsOpenShareBranch(!isOpenShareBranch);
//   };

//   // Fetch courses and sessions
//   useEffect(() => {
//     dispatch(fetchCourseData());
//     dispatch(fetchSessionData());
//   }, [dispatch]);

//   useEffect(() => {
//     if (selectedCourse) {
//       fetch(`${FULL_API_BASE_URL}/get-subjects-by-course/?course_id=${selectedCourse}`)
//         .then((res) => res.json())
//         .then((data) => {
//           const fetchedSubjects = data || [];
//           setSubjects(fetchedSubjects);
//           setSelectedSubjects(fetchedSubjects.map((s) => s.subject_id));
//         })
//         .catch((err) => console.error("Error fetching subjects:", err));
//     } else {
//       setSubjects([]);
//       setSelectedSubjects([]);
//     }
//   }, [selectedCourse]);

//   // Fetch faculty list by search key
//   const fetchFaculty = (searchKey) => {
//     if (!searchKey) {
//       setFacultyOptions([]);
//       return;
//     }
//     fetch(`${FULL_API_BASE_URL}/get-faculty-list-by-searchkey/?search_key=${searchKey}`, {
//       headers: { Authorization: `Bearer ${accessToken}` },
//     })
//       .then((res) => res.json())
//       .then((data) => {
//         const options = (data || []).map((f) => ({
//           label: `${f.emp_first_name} ${f.emp_middle_name} ${f.emp_last_name}`.trim(),
//           id: f.user_id,
//           manager_emp_id: f.manager_emp_id,
//         }));
//         setFacultyOptions(options);
//       })
//       .catch((err) => console.error("Error fetching faculty:", err));
//   };

//   const fetchStudents = (searchKey) => {
//     if (!searchKey) {
//       setStudentOptions([]);
//       return;
//     }

//     const params = new URLSearchParams();
//     params.append("search_key", searchKey);
//     if (selectedCourse) params.append("course_id", selectedCourse);
//     if (selectedSession) params.append("session_id", selectedSession);

//     fetch(`${FULL_API_BASE_URL}/search-student-across-branches?${params.toString()}`, {
//       headers: { Authorization: `Bearer ${accessToken}` },
//     })
//       .then((res) => res.json())
//       .then((data) => {
//         setStudentOptions(
//           (data || []).map((s) => ({
//             label: `${s.student_full_name} (${s.roll_number}) - ${s.branch_name}`,
//             id: s.student_id,
//             fullData: s  // Store complete student object
//           }))
//         );
//       })
//       .catch((err) => console.error(err));
//   };

//   // Save student group
//   const handleSaveGroup = async () => {
//     if (!studentGroupName.trim() || !studentGroupDesc.trim() || !selectedCourse || !selectedSession || !selectedCoordinator) {
//       setIsMessageBoxVisible(true);
//       setMessageBox(
//         <div className="Container-messageBOX">
//           <div className="messagebox-insider1">
//             <div className="loader-tc"></div>
//             <span>Please fill all required fields before saving.</span>
//           </div>
//         </div>
//       );
//       setActiveImg(ErrorImg);
//       return;
//     }

//     const payload = {
//       student_ids: (Array.isArray(selectedStudents) ? selectedStudents : []).map((id) => Number(id)),
//       branch_ids: [],
//       subject_ids: (Array.isArray(selectedSubjects) ? selectedSubjects : []).map((id) => Number(id)),
//     };

//     const url =
//       `${FULL_API_BASE_URL}/create-student-group` +
//       `?student_group_name=${encodeURIComponent(studentGroupName)}` +
//       `&student_group_desc=${encodeURIComponent(studentGroupDesc)}` +
//       `&comments=${encodeURIComponent("NA")}` +
//       `&course_id=${selectedCourse}` +
//       `&session_id=${selectedSession}` +
//       `&student_group_coord_emp_id=${Number(selectedCoordinator)}` +
//       `&client_branch_id=${clientBranchId}` +
//       `&username=${encodeURIComponent(userName)}`;

//     try {
//       const response = await fetch(url, {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//           Authorization: `Bearer ${accessToken}`,
//         },
//         body: JSON.stringify(payload),
//       });
//       const data = await response.json();

//       if (data.status === 200) {
//         setIsMessageBoxVisible(true);
//         setMessageBox(
//           <div className="Container-messageBOX">
//             <div className="messagebox-insider1">
//               <div className="loader-tc"></div>
//               <span>Student group created successfully!</span>
//             </div>
//           </div>
//         );
//         setActiveImg(InterogativeImg);
//         navigate("/student_group_dashboard");
//       } else {
//         setIsMessageBoxVisible(true);
//         setMessageBox(
//           <div className="Container-messageBOX">
//             <div className="messagebox-insider1">
//               <div className="loader-tc"></div>
//               <span>{data.message || "Failed to create student group. Please try again."}</span>
//             </div>
//           </div>
//         );
//         setActiveImg(ErrorImg);
//       }
//     } catch (error) {
//       console.error("Error creating student group:", error);
//       setIsMessageBoxVisible(true);
//       setMessageBox(
//         <div className="Container-messageBOX">
//           <div className="messagebox-insider1">
//             <div className="loader-tc"></div>
//             <span>An unexpected error occurred while creating the student group. Please try again.</span>
//           </div>
//         </div>
//       );
//       setActiveImg(ErrorImg);
//     }
//   };

//   // Define headers here
//   const headers = [
//     "Student Name",
//     "Roll Number",
//     "Course",
//     "Batch",
//     "Branch",
//     "Mobile Number",
//     "Status",
//   ];

//   // Transform selected students into table data
//   const studentTableData = (Array.isArray(selectedStudents) ? selectedStudents : []).map((studentId) => {
//     // Find the full student object from studentOptions
//     const studentOption = studentOptions.find(option => option.id === studentId);

//     if (!studentOption || !studentOption.fullData) {
//       return [];
//     }

//     const student = studentOption.fullData;

//     return [
//       student.student_full_name || "---",
//       student.roll_number || "---",
//       student.course_name || "---",
//       student.batch_name || "---",
//       student.branch_name || "---",
//       student.mobile_number || "---",
//       student.status || "---",
//       student.student_id
//     ];
//   }).filter(row => row.length > 0);

//   return (
//     <div className="create-role-container">
//       <div className="create-role-container-ques-paper-del">
//         <span className="create-role-heading">Student Group</span>
//         <div className="cr-header-btn-container">
//           <button
//             className="cr-cancel-btn"
//             onClick={() => navigate("/student_group_dashboard")}
//           >
//             CANCEL
//           </button>
//           <button className="cr-create-btn" onClick={handleSaveGroup}>
//             SAVE
//           </button>
//         </div>
//       </div>

//       <div className="ques-paper-del">
//         <div className="personal-header">
//           <div className="header">
//             <label>USER DETAILS</label>
//           </div>
//         </div>

//         <div className="accordion-content">
//           <div className="select-assign-test-container-ques-pap-del">
//             <div className="grid-container-ques-paper-del">
//               <div className="item1">
//                 <FormInputs
//                   label="Student Group Name"
//                   type="text"
//                   required
//                   value={studentGroupName}
//                   onChange={(e) => setStudentGroupName(e.target.value)}
//                 />
//               </div>

//               <div className="item2">
//                 <FormInputs
//                   label="Student Group Description"
//                   type="text"
//                   required
//                   value={studentGroupDesc}
//                   onChange={(e) => setStudentGroupDesc(e.target.value)}
//                 />
//               </div>

//               <div className="item2">
//                 <SingleSelectSearchDropdown
//                   label="Group Coordinator"
//                   width="100%"
//                   singleSelect={true}
//                   selected={selectedCoordinator}
//                   setSelected={setSelectedCoordinator}
//                   options={facultyOptions}
//                   placeholder="Search and select Coordinator..."
//                   onSearchInputChange={fetchFaculty}
//                   isRequired={true}
//                 />
//               </div>
//               <div className="item3">
//                 <DropDown
//                   label="Session"
//                   selected={selectedSession}
//                   setSelected={setSelectedSession}
//                   options={
//                     Array.isArray(sessionsData)
//                       ? sessionsData.map((session) => ({
//                           label: session.session_name,
//                           id: session.session_id,
//                         }))
//                       : []
//                   }
//                   isRequired={true}
//                 />
//               </div>

//               <div className="item4">
//                 <DropDown
//                   label="Course"
//                   selected={selectedCourse}
//                   setSelected={(val) => setSelectedCourse(val)}
//                   options={
//                     Array.isArray(coursesdata)
//                       ? coursesdata.map((course) => ({
//                           label: course.course_name,
//                           id: course.course_id,
//                         }))
//                       : []
//                   }
//                   isRequired={true}
//                 />
//               </div>

//               <div className="item5">
//                 <MultiSeledDropdown
//                   label="Subjects"
//                   width="100%"
//                   selected={selectedSubjects}
//                   setSelected={setSelectedSubjects}
//                   options={subjects.map((subject) => ({
//                     label: subject.subject_name,
//                     id: subject.subject_id,
//                   }))}
//                   showSelectAll={true}
//                   isRequired={true}
//                 />
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>

//       <div className="ques-paper-del" style={{ marginTop: "20px" }}>
//         <div className="personal-header">
//           <div className="header">
//             <label>ADD STUDENTS</label>
//           </div>
//           <div className="accordion-btn" onClick={toggleAccordionShareBranch}>
//             {isOpenShareBranch ? (
//               <div className="minus"></div>
//             ) : (
//               <div className="plus">+</div>
//             )}
//           </div>
//         </div>
//         {isOpenShareBranch && (
//           <div className="accordion-content">
//             <div className="select-assign-test-container-ques-pap-del" style={{padding: "20px 0px 20px 10px"}}>
//               <div className="grid-container-ques-paper-del">
//                 <div className="item1" style={{ gridColumn: "1 / -1"}}>
//                   <DropdownWithPagination
//                     label="Add Students"
//                     width="30%"
//                     selected={selectedStudents}
//                     setSelected={(value) => {
//                       if (Array.isArray(value)) {
//                         setSelectedStudents(value);
//                       } else if (value !== null && value !== undefined) {
//                         setSelectedStudents(prev => {
//                           const prevArray = Array.isArray(prev) ? prev : [];
//                           if (prevArray.includes(value)) {
//                             return prevArray.filter(id => id !== value);
//                           } else {
//                             return [...prevArray, value];
//                           }
//                         });
//                       } else {
//                         setSelectedStudents([]);
//                       }
//                     }}
//                     onSearchInputChange={fetchStudents}
//                     options={studentOptions}
//                     isRequired={false}
//                     itemsPerPage={4}
//                   />
//                 </div>
//               </div>
//               <AddSearchStudentTable
//                 headers={headers}
//                 data={studentTableData}
//                 searchPlaceholder="Search by Student Name..."
//                 isColumnDivVisible={isStudentTableVisible}
//                 setIsColumnDivVisible={setIsStudentTableVisible}
//                 dataClient={dataClient}
//               />
//             </div>
//           </div>
//         )}
//       </div>
//     </div>
//   );
// }

// export default StudentGroup;
